import {Component, Input, OnInit, ViewEncapsulation} from "@angular/core";
import {Subscription} from "rxjs";
import {ExchangeService} from "@aparraga/ahoracrypto-client-common/src/app/common/exchange/exchange.service";
import {
  PurchaseFlowHelperService
} from "@aparraga/ahoracrypto-client-common/src/app/common/flowhelpers/purchaseflowhelper.service";
import {StringUtils} from "@aparraga/ahoracrypto-client-common/src/app/common/utils/stringutils";
import {ExchangePriceWithRelations} from "@aparraga/ahoracrypto-api-sdk/sdk";

@Component({
    selector: 'stock-rate',
    templateUrl: './stockrate.component.html',
    styleUrls: ['./stockrate.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class StockRateComponent implements OnInit {

  protected subscriptions: Subscription[] = new Array<Subscription>();

  public _variation: number;
  get variation(): number {
    return this._variation;
  }
  @Input() set variation(value: number) {
    this._variation = value;
    this.calculateVariationsAutomatically = false;
  }

  protected calculateVariationsAutomatically = true;

  @Input() public style = null;

  _baseCurrency: string;
  get baseCurrency(): string {
    return this._baseCurrency;
  }
  @Input() set baseCurrency(value: string) {
    this._baseCurrency = value;
    this.updateCryptoInformation();
  }

  _quoteCurrency: string;
  get quoteCurrency(): string {
    return this._quoteCurrency;
  }
  @Input() set quoteCurrency(value: string) {
    this._quoteCurrency = value;
    this.updateCryptoInformation();
  }

  _exchangePrice: ExchangePriceWithRelations = null;
  get exchangePrice(): ExchangePriceWithRelations {
    return this._exchangePrice;
  }
  @Input() set exchangePrice(value: ExchangePriceWithRelations) {
    this._exchangePrice = value;
    this.updateCryptoInformation();
  }

  public constructor(protected exchangeService: ExchangeService,
                     public purchaseFlowHelperService: PurchaseFlowHelperService,
                     protected stringUtils: StringUtils) {

  }

  public ngOnInit() {

    if(this.exchangePrice == null && this.calculateVariationsAutomatically) {
      this.subscriptions.push(this.exchangeService.exchangePricesSubject$.subscribe(exchangeRates => {
        this.updateCryptoInformation();
      }));
    }
  }

  protected updateCryptoInformation() {
    if(this.baseCurrency != null && this.quoteCurrency != null) {
      this._exchangePrice = this.exchangeService.getExchangePrice(this.baseCurrency, this.quoteCurrency);
      if(this._exchangePrice != null) {
        this._variation = this._exchangePrice.last24hVariation * 100;
      }
    }
    else if(this._exchangePrice != null) {
      this._variation = this._exchangePrice.last24hVariation * 100;
    }
  }

}
